/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Report } from '../../models/invoices/segments.report.model';

export enum ActionTypes {
  Update = '[Account Segments] Update report',
  Receive = '[Account Segments] Receive report',
  Reset = '[Account Segments] Reset report'
}

export class Update implements Action {
  readonly type = ActionTypes.Update;
}

export class Receive implements Action {
  readonly type = ActionTypes.Receive;
  constructor(public payload: { report: Report; errorMessage: string }) {}
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export type ActionList = Update | Receive | Reset;
